import React, { useEffect, useState, useMemo } from "react";
import { Helmet } from "react-helmet";
import { apiUrl } from "../constants";
import axios from "axios";
import CardPhoto from "../components/card/CardPhotoToPath";
import { Box, Grid, Typography, useTheme } from "@mui/material";
import { tokens } from "../theme";
import chickenImg from "../assets/img/chickenTender.png";
import { useSelector } from "react-redux";
import useCheckToken from "../hooks/useCheckToken";
import useExchangeToken from "../hooks/useExchangeToken";
import cpf from '../assets/img/CPF.jpg'

const CardPhotoMemo = React.memo(CardPhoto);

const BUList = () => {
  const exchangeToken = useExchangeToken();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [isTokenExchanged, setIsTokenExchanged] = useState(false);
  const [bu, setBu] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const buList = [
    { id: 1, name: "แปรรูปไก่", fileLocation: chickenImg },
  ];

  useCheckToken();
  const ac_token = useSelector((state) => state.auth.access_token);
  const bu_store = useSelector((state) => state.auth.bu);

  //console.log(isTokenExchanged)

  useEffect(() => {
    const fetchInitialTokenAndData = async () => {
      try {
        const token = await exchangeToken(); // ตรวจสอบหรือแลกเปลี่ยนโทเค็น
        if (token) {
          setIsTokenExchanged(true); // ระบุว่าโทเค็นพร้อม
        }
      } catch (err) {
        console.error("Error exchanging token:", err);
        setError("Failed to exchange token");
      }
    };

    fetchInitialTokenAndData();
  }, [exchangeToken]);

  useEffect(() => {
    const fetchMyAPI = async () => {
      if (!ac_token) return; // ถ้าไม่มีโทเค็น ให้รอ
      setLoading(true);
      try {
        const response = await axios.get(`${apiUrl.MASTER_BU}`, {
          headers: {
            Authorization: `Bearer ${ac_token}`,
            // "X-xss-protection": "1; mode=block;",
            // "X-frame-options": "SAMEORIGIN",
            // "X-content-type-options": "nosniff",
            // "Cache-Control": "no-cache, private",
            // "Strict-Transport-Security": "max-age=31536000; includeSubDomains; preload",
            // "Content-Security-Policy": "upgrade-insecure-requests; frame-ancestors 'self'"
          },
        });

        if (response.status === 200) {
          setBu(response.data.BU);
        }
      } catch (err) {
        setError(err.message);
        console.error("Error fetching BU data:", err);
      } finally {
        setLoading(false);
      }
    };

    if (isTokenExchanged && ac_token) {
      fetchMyAPI(); // เรียก API เมื่อโทเค็นพร้อม
    }
  }, [isTokenExchanged, ac_token]);

  bu.sort((a, b) => {
    if (a.length !== b.length) {
      return a.length - b.length;
    }
    return a.localeCompare(b);
  });

  // const filterBUData = (bu_store, bu_from_api) => {
  //   if (bu_store === "Engineering Center") {
  //     return bu_from_api; // แสดงผลทั้งหมดถ้า bu_store เป็น 'all'
  //   } else if (bu_store === "All") {
  //     return bu_from_api;
  //   } else if (bu_store === "None") {
  //     return bu_from_api;
  //   } else if (bu_store === "-") {
  //     return bu_from_api;
  //   }
  //   return bu_from_api.filter((item) => item === bu_store); 
  // };

  const filterBUData = (bu_store, bu_from_api) => {
    const value = (bu_store ?? "").trim().toLowerCase();

    if (
      value === "all" ||
      value === "engineering center" ||
      value === "none" ||
      value === "-"
    ) {
      return bu_from_api;
    }

    return bu_from_api.filter(
      (item) => item?.toLowerCase() === value
    );
  };

  // const buData = useMemo(() => {
  //   const filteredBu = filterBUData(bu_store, bu); 
  //   return filteredBu.length === 0
  //     ? []
  //     : filteredBu.map((name, index) => ({ key: index, name, fileLocation: chickenImg}));
  // }, [bu, bu_store]);

  const imageMap = {
    "แปรรูปไก่": chickenImg,
    "FOOD AND BEVERAGE": cpf,
  };

  const buData = useMemo(() => {
    const filteredBu = filterBUData(bu_store, bu);

    return filteredBu.length === 0
      ? []
      : filteredBu.map((name, index) => ({
        key: index,
        name,
        fileLocation: imageMap[name] ?? cpf,
      }));
  }, [bu, bu_store]);



  return (
    <Box style={{ width: "100%", height: "93.5vh" }}>
      <Helmet>
        <title>BU | MES</title>
      </Helmet>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <Box
            m="1%"
            display="grid"
            gridTemplateColumns="repeat(12, 1fr)"
            gridAutoRows={buData.length > 6 ? "50%" : "100%"}
            columnGap="1%"
            rowGap="6%" 
          >
            {buData.map((item) => (
              <Box
                key={item.key || item.id}
                gridColumn="span 2"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <CardPhotoMemo
                  name={item.name}
                  fileLocation={item.fileLocation || chickenImg}
                />
              </Box>
            ))}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default BUList;

